import Alert from "@pathwright/ui/src/components/alert/Alert"
import LazyRedactorEditor from "@pathwright/ui/src/components/richtext/LazyRedactorEditor"
import classnames from "classnames"
import Text from "lib/core/components/text/Text"
import PropTypes from "prop-types"
import { Component } from "react"

class SubmissionText extends Component {
  constructor(props) {
    super(props)
    this.state = {
      text: this.props.completion
        ? this.props.completion.submission_text || ""
        : ""
    }
  }

  // set error if character limit is exceeded
  handleValueChange = _.debounce((value) => {
    this.setState({ text: value })
    if (value && value.length > 3000) {
      this.setState({
        error:
          "3k character limit exceeded, please shorten answer or submit answer as a document"
      })
    } else if (this.state.error) {
      this.setState({ error: null })
    }
  }, 250)

  render() {
    const { step, completion, submission_instructions, onTextSubmitted } =
      this.props
    const isCompleted = completion.progress === 1

    const submittedClassName = classnames(
      "SubmissionText__submission",
      "SubmissionArea",
      { completed: isCompleted }
    )

    return (
      <div className="SubmissionText content-opt-out">
        <Text
          className="content-completion-embed"
          html={submission_instructions}
          templateContext={this.context}
          executeScripts={true}
          theme={true}
          latex={true}
        />
        <div className={submittedClassName}>
          {!isCompleted ? (
            <h3>You have not submitted:</h3>
          ) : (
            <h3>You submitted:</h3>
          )}
          {!isCompleted ? (
            <div className="pw-field richtext form-group">
              <LazyRedactorEditor
                name="SubmissionRichtext"
                onChange={(value) => {
                  this.handleValueChange(value)
                  onTextSubmitted(value)
                }}
                value={this.state.text || ""}
              />
            </div>
          ) : (
            <div className="SubmissionCard">
              <Text
                className="content-completion-embed"
                html={this.state.text || ""}
                templateContext={this.context}
                theme={true}
                latex={true}
              />
            </div>
          )}
          {this.state.error && <Alert error={this.state.error} />}
        </div>
      </div>
    )
  }
}

SubmissionText.displayName = "SubmissionText"

SubmissionText.contextTypes = {
  school: PropTypes.object,
  user: PropTypes.object
}

export default SubmissionText
